import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  BUILDING_FORM_BANK_OWNER_FIELD_MAX_LENGTH,
  BUILDING_FORM_FIELD_NAME_BANK_OWNER,
} from '../../BuildingForm.constants'

function BankOwnerField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Building.BankOwnerLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={BUILDING_FORM_BANK_OWNER_FIELD_MAX_LENGTH}
      name={BUILDING_FORM_FIELD_NAME_BANK_OWNER}
      placeholder={t('Building.BankOwnerPlaceholderKey')}
    />
  )
}

export default BankOwnerField
